export { default } from './ParkingTable';
export { default as ParkingTable } from './ParkingTable';
export type { ParkingLotRowData } from './ParkingTable';
export { UnSortableField } from './ParkingTable';
export { SortTableField } from './ParkingTable';
